import React from 'react';
import Ideology from '../Ideology';

type Props = {};

const IdeologyConatainer = (props: Props) => {
  return <Ideology />;
};

export default IdeologyConatainer;
